export function hasRole(user, role) {
  return user?.roles?.includes(role)
}

export function hasAnyRole(user, roles = []) {
  return roles.some(role => user?.roles?.includes(role))
}

export function hasPermission(user, permission) {
  return user?.permissions?.includes(permission)
}

export function hasAnyPermission(user, permissions = []) {
  return permissions.some(permission => user?.permissions?.includes(permission))
}